import './App.css';
import V2HomeCard from './V2HomeCard';
import { getDevices } from './QueryDevice';
import { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';

import img_tablet from './tablet.png';

function V2Devices({ menu }) {
    const navigate = useNavigate();
    const [devices, setDevices] = useState([]);

    function loadDevices() {
        getDevices().then(
            (response) => {
                setDevices(response.data);
            }
        ).catch(
            (error) => {
                console.log(error);
            }
        )
    }

    useEffect(
        () => {
            loadDevices();
        },
        [],
    )

    return (
        <div>
            {menu}
            <V2HomeCard>
                <DataTable
                    value={devices}
                    paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]}
                    stripedRows
                >
                    <Column
                        key={1}
                        header='Screen'
                        field='title'
                        body={
                            (p) =>
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        cursor: 'pointer',
                                    }}
                                    onClick={
                                        () => {
                                            navigate(`/device/campaigns/?device_id=${p.id}`)
                                        }
                                    }
                                >
                                    <div style={{ marginRight: '1em' }}>
                                        <img src={img_tablet} width={42} />
                                    </div>
                                    <div>
                                        {p.title}
                                    </div>
                                </div>
                        }
                    />
                    <Column
                        key={1}
                        header='Actions'
                        body={
                            (p) =>
                                <div>
                                    <Button
                                        label='View details'
                                        size='small'
                                        outlined
                                        severity='secondary'
                                        onClick={
                                            () => {
                                                navigate(`/devices/how_to_connect/?device_id=${p.id}`)
                                            }
                                        }
                                    />
                                </div>
                        }
                    />
                    <Column
                        key={2}
                        header='Allow external advertisers'
                        field='status'
                        body={
                            (p) => <div>
                                {p.allow_external_advertisers ? 'yes' : 'no'}
                            </div>
                        }
                    />
                </DataTable>
            </V2HomeCard>
        </div>
    );
}

export default V2Devices;